/* Happymami · Home. JS sin dependencias; cada bloque se activa solo si existe en la página. */
(function () {
  'use strict';
  if (window.__hmhLoaded) return;
  window.__hmhLoaded = true;
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('hmh-js');

  /* Aparición al entrar en pantalla */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.hmh-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el, i) {
      if (!el.style.getPropertyValue('--hmh-d')) el.style.setProperty('--hmh-d', (Math.min(i % 4, 3) * 0.08) + 's');
      io.observe(el);
    });
  }

  /* Cómo funciona: 5 estados (4 preguntas + resultado) que avanzan solos hasta que la usuaria elige uno */
  function initProc(sec) {
    var vis = sec.querySelector('[data-hmh-pvis]');
    var steps = sec.querySelectorAll('[data-hmh-step]');
    if (!vis || !steps.length) return;
    var caption = vis.querySelector('[data-hmh-caption]');
    var resultEl = sec.querySelector('[data-hmh-caption-result]');
    var result = resultEl ? resultEl.getAttribute('data-hmh-caption-result') : '';
    var dots = vis.querySelectorAll('.hmh-dots i');
    // La forma enseña las 3 formas (6 s de ciclo) antes de pasar al paso 2
    var DUR = [6600, 4400, 4400, 4400, 5600];
    var cur = 0, timer = 0, manual = false, running = false;
    steps.forEach(function (s, k) { s.style.setProperty('--hmh-step-ms', DUR[k] + 'ms'); });
    function go(i) {
      cur = i;
      vis.setAttribute('data-step', String(i));
      steps.forEach(function (s, k) {
        s.classList.toggle('is-on', k === i);
        s.classList.toggle('is-done', k < i);
        s.setAttribute('aria-pressed', k === i ? 'true' : 'false');
      });
      dots.forEach(function (d, k) { d.className = k === i ? 'is-on' : (k < i ? 'is-done' : ''); });
      if (caption) caption.textContent = i === 4 ? result : steps[i].getAttribute('data-caption');
    }
    function loop() {
      clearTimeout(timer);
      if (manual || reduce || !running) return;
      timer = setTimeout(function () { go((cur + 1) % 5); loop(); }, DUR[cur]);
    }
    function start() {
      if (running) return;
      running = true;
      sec.classList.add('is-run');
      go(0);
      loop();
    }
    steps.forEach(function (s, k) {
      s.addEventListener('click', function () {
        manual = true;
        sec.classList.add('is-manual');
        sec.classList.add('is-run');
        clearTimeout(timer);
        go(k);
      });
    });
    // Antes de empezar se ve el pecho quieto; arranca cuando el contenedor ya lleva un 25 % de la pantalla desde abajo
    vis.setAttribute('data-step', '-1');
    if (caption) caption.textContent = steps[0].getAttribute('data-caption');
    if (reduce || !('IntersectionObserver' in window)) { go(0); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { start(); if (!manual) { clearTimeout(timer); loop(); } }
        else clearTimeout(timer);
      });
    }, { rootMargin: '0px 0px -25% 0px', threshold: 0 }).observe(vis);
  }

  /* Somos matronas: en escritorio, los botones cambian foto y texto (no pasa solo); en móvil es un carrusel
     que desliza con el dedo, con flechas o puntos y pasa solo cada 5 s (se pausa 3 s si la usuaria lo toca).
     El botón avisa al configurador del pack recomendado cuando baja a él. */
  function initS2(sec) {
    if (sec.__hmhS2) return;
    var slides = Array.prototype.slice.call(sec.querySelectorAll('[data-hmh-s2-slide]'));
    var n = slides.length;
    if (!n) return;
    sec.__hmhS2 = true;
    var tabs = sec.querySelectorAll('[data-hmh-s2-tab]');
    var dots = sec.querySelectorAll('[data-hmh-s2-dot]');
    var panels = sec.querySelectorAll('[data-hmh-s2-panel]');
    var track = sec.querySelector('[data-hmh-s2-track]');
    var frame = sec.querySelector('[data-hmh-s2-img]');
    var mobile = window.matchMedia('(max-width: 900px)');
    var idx = 0, last = Date.now(), pause = 0, inView = true;

    function go(i, manual, focus) {
      idx = ((i % n) + n) % n;
      last = Date.now();
      if (manual) pause = last + 3000;
      if (track) track.style.setProperty('--hmh-i', idx);
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === idx); });
      tabs.forEach(function (t, k) {
        t.setAttribute('aria-selected', k === idx ? 'true' : 'false');
        t.tabIndex = k === idx ? 0 : -1;
      });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
      panels.forEach(function (p, k) {
        p.classList.toggle('is-on', k === idx);
        if (k === idx) p.removeAttribute('aria-hidden'); else p.setAttribute('aria-hidden', 'true');
      });
      if (focus && tabs[idx]) tabs[idx].focus();
    }
    var prev = sec.querySelector('[data-hmh-s2-prev]');
    var next = sec.querySelector('[data-hmh-s2-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1, true); });
    if (next) next.addEventListener('click', function () { go(idx + 1, true); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i, true); }); });
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { go(i, true); });
      t.addEventListener('keydown', function (e) {
        var to = null;
        if (e.key === 'ArrowRight') to = i + 1;
        else if (e.key === 'ArrowLeft') to = i - 1;
        else if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = n - 1;
        if (to !== null) { e.preventDefault(); go(to, true, true); }
      });
    });

    /* Deslizar con el dedo (solo en móvil) */
    if (frame) {
      var x0 = null, y0 = 0;
      frame.addEventListener('pointerdown', function (e) {
        if (!mobile.matches || (e.target.closest && e.target.closest('button'))) return;
        x0 = e.clientX; y0 = e.clientY;
      });
      frame.addEventListener('pointercancel', function () { x0 = null; });
      frame.addEventListener('pointerup', function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0, dy = e.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1), true);
      });
    }

    /* Pasa solo en móvil, solo con la sección a la vista y si la usuaria no ha pedido menos movimiento */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; }).observe(sec);
    }
    if (!reduce) {
      var iv = setInterval(function () {
        if (!document.body.contains(sec)) { clearInterval(iv); return; }
        var now = Date.now();
        if (!mobile.matches || !inView || document.hidden || now < pause) { last = now; return; }
        if (now - last >= 5000) go(idx + 1, false);
      }, 200);
    }

    sec.querySelectorAll('[data-hmh-preselect]').forEach(function (a) {
      a.addEventListener('click', function () {
        var pack = a.getAttribute('data-hmh-preselect');
        try { sessionStorage.setItem('hmh_preselect_pack', pack); } catch (err) { /* sin almacenamiento */ }
        document.dispatchEvent(new CustomEvent('hmh:preselect', { detail: { pack: pack } }));
      });
    });
  }

  /* Tarjetas de producto: el color cambia la foto */
  function initSwap(card) {
    var imgs = card.querySelectorAll('.hmh-pimg img');
    var btns = card.querySelectorAll('[data-hmh-sw]');
    var price = card.querySelector('[data-hmh-price]');
    var add = card.querySelector('[data-hmh-add]');
    function setVariant(b) {
      if (!b) return;
      if (price && b.dataset.price && price.textContent !== b.dataset.price) {
        price.classList.add('is-swap');
        setTimeout(function () { price.textContent = b.dataset.price; price.classList.remove('is-swap'); }, 160);
      }
      if (add && add.tagName === 'BUTTON' && b.dataset.id) {
        add.dataset.id = b.dataset.id;
        var ok = b.dataset.avail !== 'false';
        add.disabled = !ok;
        add.textContent = ok ? card.dataset.lAdd : card.dataset.lSoldout;
      }
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
        btns.forEach(function (x, k) { x.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        setVariant(b);
      });
    });
    if (add && add.tagName === 'BUTTON') {
      add.addEventListener('click', function () {
        if (add.disabled || add.classList.contains('is-busy')) return;
        var label = add.textContent;
        add.classList.add('is-busy');
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var body = new FormData();
        body.append('id', add.dataset.id);
        body.append('quantity', '1');
        if (cart && cart.getSectionsToRender) {
          body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
          body.append('sections_url', window.location.pathname);
        }
        fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: body })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { add.textContent = res.description || res.message || label; setTimeout(function () { add.textContent = label; }, 2200); return; }
            if (cart && cart.renderContents) cart.renderContents(res);
            else window.location = (window.routes && window.routes.cart_url) || '/cart';
            add.classList.add('is-done');
            setTimeout(function () { add.classList.remove('is-done'); }, 1600);
          })
          .catch(function () {})
          .finally(function () { add.classList.remove('is-busy'); });
      });
    }
  }

  /* Anticólicos: al tocar con el dedo la fila se anima como al pasar el ratón */
  function initAnti(list) {
    list.querySelectorAll('li').forEach(function (li) {
      var t;
      function on() { clearTimeout(t); li.classList.add('is-press'); }
      function off() { clearTimeout(t); t = setTimeout(function () { li.classList.remove('is-press'); }, 320); }
      li.addEventListener('pointerdown', on);
      li.addEventListener('pointerup', off);
      li.addEventListener('pointercancel', off);
      li.addEventListener('pointerleave', off);
    });
  }

  /* Comparativa: las barras se llenan al entrar */
  function initTable(el) {
    if (reduce || !('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { el.classList.add('is-in'); io.disconnect(); } });
    }, { threshold: 0.25 });
    io.observe(el);
  }

  /* Configurador: es el asistente real del tema (happymami-bundle), en la propia página.
     Los botones de la home bajan hasta él; si piden un pack, se elige en cuanto el asistente termina. */
  var PACK_KEY = { '2': 'two', 'pack': 'plus', 'one': 'one' };
  function initConfig(sec) {
    if (sec.__hmhCfg) return;
    sec.__hmhCfg = true;
    var pending = null;
    try { pending = sessionStorage.getItem('hmh_preselect_pack'); } catch (err) { /* sin almacenamiento */ }
    function applyPack() {
      if (!pending) return;
      var key = PACK_KEY[pending];
      var after = sec.querySelector('#happymami-vaso-selector');
      var btn = key && sec.querySelector('[data-hm-select-pack="' + key + '"]');
      if (after && !after.hidden && btn) {
        btn.click();
        pending = null;
        try { sessionStorage.removeItem('hmh_preselect_pack'); } catch (err) { /* sin almacenamiento */ }
      }
    }
    document.addEventListener('happymami:complete', function () { setTimeout(applyPack, 400); });
    document.addEventListener('hmh:preselect', function (e) { pending = e.detail && e.detail.pack; setTimeout(applyPack, 600); });
  }

  /* Panel de selección: refleja en vivo la foto real y los pasos que elige la clienta en el asistente */
  function initAside(sec) {
    var aside = sec.querySelector('[data-hmh-aside]');
    var root = sec.querySelector('#happymami-bundle');
    if (!aside || !root || aside.__hmhOn) return;
    aside.__hmhOn = true;
    var img = aside.querySelector('[data-hmh-aside-img]');
    var extras = aside.querySelector('[data-hmh-aside-extras]');
    var empty = aside.querySelector('[data-hmh-aside-empty]');
    var designBox = aside.querySelector('[data-hmh-aside-design]');
    var stepsEl = aside.querySelector('[data-hmh-aside-steps]');
    var sel = aside.querySelector('[data-hmh-aside-sel]');
    var placeholder = img.getAttribute('data-placeholder');
    var answers = [];
    var queued = false;
    var wasWizard = false;
    var started = false;
    var lastSteps = '';
    var lastSel = '';
    var modifyBtn = aside.querySelector('[data-hmh-modify]');

    function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function setImg(el, src) {
      if (!src || el.getAttribute('src') === src) return;
      el.classList.add('is-swap');
      setTimeout(function () { el.setAttribute('src', src); el.classList.remove('is-swap'); }, 160);
    }
    function previewSrc(name) {
      var el = root.querySelector('[data-hm-preview="' + name + '"] .hm-preview__img.is-on');
      return el ? (el.getAttribute('src') || '') : '';
    }

    function render() {
      queued = false;
      // 1) Pasos de la tetina. Con el asistente a la vista (diseñando o modificando) solo cuentan las respuestas
      // de esta pasada, así que al empezar a modificar el diseño el panel se vacía por completo. Con los packs a la
      // vista se usa el resumen final del asistente.
      var wizBox = root.querySelector('#happymami-wizard-container');
      var wizVisible = !!wizBox && !wizBox.hidden;
      if (wizVisible && !wasWizard && started) answers = [];
      wasWizard = wizVisible;
      started = true;
      var rows = [];
      if (wizVisible) {
        rows = answers;
      } else {
        root.querySelectorAll('[data-hm-design-list] > *').forEach(function (r) {
          var l = txt(r.querySelector('.hm-design__label')).replace(/:\s*$/, '');
          var v = txt(r.querySelector('.hm-design__value'));
          if (l || v) rows.push({ q: l, a: v, step: r.getAttribute('data-hm-edit-step') || '' });
        });
        if (!rows.length) rows = answers;
      }
      var stepsHtml = rows.map(function (r) {
        var inner = '<b>' + esc(r.q) + (r.q ? ':' : '') + '</b><span>' + esc(r.a) + '</span>';
        return '<li>' + (r.step ? '<button type="button" data-hmh-edit="' + esc(r.step) + '">' + inner + '</button>' : inner) + '</li>';
      }).join('');
      if (stepsHtml !== lastSteps) {
        // Solo se anima lo que llega nuevo; el resto no se vuelve a pintar
        var prevCount = lastSteps ? stepsEl.children.length : 0;
        stepsEl.innerHTML = stepsHtml;
        for (var si = prevCount; si < stepsEl.children.length; si++) stepsEl.children[si].classList.add('is-new');
        lastSteps = stepsHtml;
      }
      designBox.hidden = !rows.length;

      // 2) Pack, flujo, color, capacidad y precio (solo cuando ya se ve el selector de packs)
      var after = root.querySelector('#happymami-vaso-selector');
      var inPacks = after && !after.hidden;
      var items = [];
      if (inPacks) {
        var pack = root.querySelector('.hm-pack.is-selected');
        if (pack) items.push([sel.dataset.lPack, esc(txt(pack.querySelector('.hm-pack__name')))]);
        // Con «segundo biberón diferente» se muestran las dos opciones separadas por « / »
        var sec2 = root.querySelector('[data-hm-second]');
        var two = !!(sec2 && sec2.classList.contains('is-open'));
        function pair(a, b) { return b ? a + ' / ' + b : a; }
        function dotOf(btn) {
          var cs = window.getComputedStyle(btn);
          return '<i class="hmh-aside__dot" style="background-color:' + cs.backgroundColor + ';background-image:' + (cs.backgroundImage === 'none' ? 'none' : cs.backgroundImage) + '"></i>';
        }
        var flow = root.querySelector('[data-hm-flow].is-selected');
        var flowB = two ? root.querySelector('[data-hm-flow-b].is-selected') : null;
        if (flow) items.push([sel.dataset.lFlow, esc(pair(txt(flow), flowB && txt(flowB)))]);
        var col = root.querySelector('[data-hm-color].is-selected');
        var colB = two ? root.querySelector('[data-hm-color-b].is-selected') : null;
        if (col) {
          var html = dotOf(col) + esc(col.getAttribute('data-hm-color') || '');
          if (colB) html += '<span class="hmh-aside__sep">/</span>' + dotOf(colB) + esc(colB.getAttribute('data-hm-color-b') || '');
          items.push([sel.dataset.lColor, html]);
        }
        var size = root.querySelector('[data-hm-size].is-selected');
        var sizeB = two ? root.querySelector('[data-hm-size-b].is-selected') : null;
        if (size) items.push([sel.dataset.lSize, esc(pair(txt(size), sizeB && txt(sizeB)))]);
        var price = pack && txt(pack.querySelector('.hm-pack__price strong'));
        if (price) items.push([sel.dataset.lTotal, esc(price), true]);
      }
      var selHtml = items.map(function (it) { return '<div' + (it[2] ? ' class="is-total"' : '') + '><dt>' + it[0] + '</dt><dd>' + it[1] + '</dd></div>'; }).join('');
      if (selHtml !== lastSel) { sel.innerHTML = selHtml; lastSel = selHtml; }
      sel.hidden = !items.length;
      if (modifyBtn) modifyBtn.hidden = !inPacks;
      empty.hidden = !!(rows.length || items.length);

      // 3) Foto real del biberón elegido y, en el pack completo, termo y dosificador
      setImg(img, (inPacks && previewSrc('vaso')) || placeholder);
      var plus = root.querySelector('.hm-pack.is-selected[data-pack="plus"]');
      var html = '';
      var secOpen = root.querySelector('[data-hm-second]');
      var srcB = inPacks && secOpen && secOpen.classList.contains('is-open') ? previewSrc('vaso-b') : '';
      if (srcB) html += '<img src="' + esc(srcB) + '" alt="">';
      if (inPacks && plus) {
        ['extra-termo', 'extra-dosificador'].forEach(function (n) {
          var s = previewSrc(n);
          if (s) html += '<img src="' + esc(s) + '" alt="">';
        });
      }
      if (extras.innerHTML !== html) extras.innerHTML = html;
    }
    function schedule() { if (!queued) { queued = true; requestAnimationFrame(render); } }

    // Respuestas del asistente mientras se contestan. Tres vías para no depender de cómo el asistente pinte los pasos:
    // el clic (en captura, porque el asistente frena la propagación), la clase .selected y el cambio de título del paso.
    function record(q, a) {
      if (!a) return;
      var wb = root.querySelector('#happymami-wizard-container');
      if (wb && wb.hidden) return;
      var i = -1;
      answers.forEach(function (r, k) { if (i < 0 && r.q === q) i = k; });
      if (i >= 0) answers = answers.slice(0, i);
      answers.push({ q: q, a: a });
      schedule();
    }
    function stepTitle() { return txt(root.querySelector('#happymami-wizard .step-title')); }
    function optLabel(opt) { return txt(opt.querySelector('.hm-option-label')) || txt(opt); }
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest || !root.contains(t)) return;
      var opt = t.closest('#happymami-wizard .option');
      if (opt) { record(stepTitle(), optLabel(opt)); return; }
      if (t.closest('#happymami-wizard .btn-back')) { answers.pop(); schedule(); }
    }, true);
    var wiz = root.querySelector('#happymami-wizard');
    if (wiz) {
      var lastTitle = stepTitle();
      new MutationObserver(function () {
        var sOpt = wiz.querySelector('.option.selected');
        var title = stepTitle();
        if (sOpt && title === lastTitle) record(title, optLabel(sOpt));
        lastTitle = title;
        schedule();
      }).observe(wiz, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'], characterData: true });
    }
    aside.addEventListener('click', function (e) {
      var m = e.target.closest && e.target.closest('[data-hmh-modify]');
      var ed = e.target.closest && e.target.closest('[data-hmh-edit]');
      var target = null;
      if (m) target = root.querySelector('[data-hm-reset]');
      else if (ed) target = root.querySelector('[data-hm-edit-step="' + ed.getAttribute('data-hmh-edit') + '"]');
      if (target) { e.preventDefault(); target.click(); }
    });
    document.addEventListener('happymami:edit', function () { answers = []; schedule(); });
    document.addEventListener('happymami:complete', function () { schedule(); setTimeout(schedule, 400); });

    new MutationObserver(schedule).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'src', 'hidden'] });
    schedule();
  }

  /* Todos los botones de «diseñar biberón» de la home bajan al configurador «Diseña tu Happymami»,
     también los de la cabecera que apuntan a la ficha del biberón. */
  var cfgBound = false;
  function bindDesignLinks() {
    if (cfgBound) return;
    cfgBound = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
      if (a.hasAttribute('data-hm-direct')) return; // enlace que debe navegar a la ficha, sin bajar al configurador
      var target = document.getElementById('hm-disena');
      if (!target) return;
      var href = a.getAttribute('href') || '';
      var isHash = href === '#hm-disena';
      var isProduct = false;
      try {
        var u = new URL(a.href, location.href);
        isProduct = u.origin === location.origin && /\/products\/biberon-personalizado\/?$/.test(u.pathname);
      } catch (err) { /* enlace no válido */ }
      if (!isHash && !isProduct) return;
      e.preventDefault();
      var header = document.querySelector('.hm-chrome');
      var offset = (header ? header.getBoundingClientRect().height : 0) + 12;
      var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', '#hm-disena');
    });
  }

  function initAll(scope) {
    initReveal(scope);
    scope.querySelectorAll('[data-hmh-proc]').forEach(initProc);
    scope.querySelectorAll('[data-hmh-s2]').forEach(initS2);
    scope.querySelectorAll('[data-hmh-swap]').forEach(initSwap);
    scope.querySelectorAll('.hmh-anti__list').forEach(initAnti);
    scope.querySelectorAll('[data-hmh-table]').forEach(initTable);
    scope.querySelectorAll('[data-hmh-cfg]').forEach(initConfig);
    scope.querySelectorAll('[data-hmh-cfg]').forEach(initAside);
  }
  function boot() { initAll(document); bindDesignLinks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
